import {Popup} from '@mintdata/mint-kit/impl/components/popover/Popup';
import {PopupKind} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import * as React from 'react';

export class Window extends Popup
{
    public getKind():PopupKind
    {
        return PopupKind.Window;
    }
}
